import LocationDetails from './LocationDetails';
export default LocationDetails;
